import * as types from "../types/permissionsType";
import { initialPermissionState } from "../initialState"

export const permissions = (state = initialPermissionState, action) => {
  switch (action.type) {
    case types.IS_PERMISSION: 
       return Object.assign({}, state, action.permission);
    case types.IS_NOTPERMISSION:
      return Object.assign({}, state, action.permission);
    default:
      return {...state};
  }
};